module.exports = __webpack_public_path__ + "assets/img/00182.ad081e1d.png";